import React, {Fragment,useState, useEffect} from 'react'
import { useHistory } from "react-router-dom";
import Moment from 'react-moment';
import 'moment/locale/es';
import axios from 'axios';
import Swal from 'sweetalert2'
import { BsPlayFill } from "react-icons/bs";
import { FaRegDotCircle } from "react-icons/fa";

import Context from '../../Context'
import {CategoriaTitulo} from '../CategoriaTitulo'

export const ItemSlider = (props) => {
  const history = useHistory();
    
    const navigateTo = (id,tipo) => {
        console.log('navigate:: visualiza evento')
        let BajoDemanda = false
        if(tipo == 2){BajoDemanda = true} 
        props.logEvento(id,BajoDemanda,'visualiza-evento','true')

        id != '-1' ?
        history.push(`/evento/${id}`)
        :
        history.push(`/`)
    }

    
    return  (
        <Context.Consumer>
            {
                ({isAuth,modaIsOpen,activateAuth,modaToggle,showRecovery,showRecoveryToggle}) => {
               
                return(
                <Fragment>
                     {props.eventosInscritos.find(o => o.idEvento === props.evento.idEvento) &&
                    <div className="caja" >
                    <div className="card cot">
                    {
                            props.evento.idTipoEvento == 7 ?
                            <>
                                <img  className="card-img-top noclick"  src={props.evento.imagenFicha !== null? props.evento.imagenFicha : `${process.env.REACT_APP_SITE_URL}assets/images/eventoDefault.png`} alt="Card image cap" />
                                <div className="card-body">
                                    <div className="div-btn">
                                        <span  className="btn btn-gris noclick" ><Moment format="DD">{props.evento.fechaEvento}</Moment> de <Moment format="MMMM">{props.evento.fechaEvento}</Moment> del <Moment format="yyyy">{props.evento.fechaEvento}</Moment> ({props.evento.horaInicio})</span> 
                                    </div>
                                </div>

                            </>
                            :
                            <>
                            {
                                props.evento.idTipoEvento == 4 || props.evento.idTipoEvento == 1 ?
                                <>
                                    <img  className="card-img-top" onClick={() => navigateTo(props.evento.idEvento,props.evento.idTipoEvento)} src={props.evento.imagenFicha !== null? props.evento.imagenFicha : `${process.env.REACT_APP_SITE_URL}assets/images/eventoDefault.png`} alt="Card image cap" />
                                    <div className="card-body">
                                        <div className="div-btn">
                                            <span  className="btn btn-directo" onClick={() => navigateTo(props.evento.idEvento,props.evento.idTipoEvento)} ><span className="iconobtn"><FaRegDotCircle  color="#fff" size="20px"/></span> EMITIENDO EN DIRECTO </span> 
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                {
                                    props.evento.idTipoEvento == 5 ?
                                    <>
                                        <img  className="card-img-top" onClick={() => navigateTo(props.evento.idEvento,props.evento.idTipoEvento)} src={props.evento.imagenFicha !== null? props.evento.imagenFicha : `${process.env.REACT_APP_SITE_URL}assets/images/eventoDefault.png`} alt="Card image cap" />
                                        <div className="card-body">
                                            <div className="div-btn">
                                            <span  className="btn btn-play" onClick={() => navigateTo(props.evento.idEvento,props.evento.idTipoEvento)} ><span className="iconobtn"><BsPlayFill  color="#fff" size="20px"/></span> VER CONTENIDO</span> 
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <img  className="card-img-top" onClick={() => navigateTo(props.evento.idEvento,props.evento.idTipoEvento)} src={props.evento.imagenFicha !== null? props.evento.imagenFicha : `${process.env.REACT_APP_SITE_URL}assets/images/eventoDefault.png`} alt="Card image cap" />
                                        <div className="card-body">
                                            <div className="div-btn">
                                                <span  className="btn btn-play" onClick={() => navigateTo(props.evento.idEvento,props.evento.idTipoEvento)} ><span className="iconobtn"><BsPlayFill  color="#fff" size="20px"/></span> VER GRABACIÓN</span> 
                                            </div>
                                        </div>
                                    </>
    
                                }
                                 </>

                            }
                             
                            </>

                        }
                    </div></div>}
                </Fragment> 
                )
            }
        }   
        </Context.Consumer>
    )
    
}



